import pino from "pino";

import { getLoggerBindings } from "@voxmedia/duet-utils/logging";

const root = pino({
  enabled: process.env.DISABLE_GRAPHQL_LOGGING !== "true",
  base: undefined,
  /**
   * Use write option since serialize is not working in middleware.
   * See: https://github.com/vercel/next.js/discussions/33898
   */
  browser: {
    write(obj) {
      try {
        console.log(JSON.stringify(obj));
      } catch (err) {
        if (err instanceof Error) {
          // Without a `replacer` argument, stringify on Error results in `{}`
          console.log(JSON.stringify(err, ["name", "message", "stack"]));
        }

        console.log(JSON.stringify({ message: "Unknown error type" }));
      }
    },
  },
  level: process.env.LOG_LEVEL || "info",
});

export const log = root.child(getLoggerBindings("duet-framework"));
